import { useQuery } from 'react-query'
import axios from 'axios'
import { getApiServer } from '../../utils/helpers'

export default function useAnnouncement (announcementId) {
  return useQuery(['announcement', announcementId], async () => {
    const announcement = await axios.get(`${getApiServer()}/announcements/${announcementId}`, { withCredentials: true })
    return announcement.data
  }, {
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: 0,
    keepPreviousData: true,
    enabled: false
  })
}